import React, { Component } from "react";
import TimeInput from "../common/Time-input";
import Input from "../common/Input";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import { addDays, isBefore } from 'date-fns';

import Modal from 'react-modal';
import moment from "moment";
Modal.setAppElement('#root');

const mapStateToProps = (state) => ({
  business: state.business,
  headers: state.headers(),
  businessCatergories: state.businessCatergories,
  locations: state.locations,
  countries: state.countries,
  postOptions: state.postOptions,
  opening_hours: state.opening_hours,
  bookingSettings: state.bookingSettings,
  closing_hours: state.closing_hours,
  token: state.token,

});

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
  },
};
export default connect(mapStateToProps)(
  class OpeningHours extends Component {
    state = {
      active_form: 1,
      cities: [],
      errors: {},
      openHours: {},
      timeModalIsOpen: false,
      dateModalIsOpen: false,
      dateRange: [
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 1),
          key: 'selection'
        }
      ]
    };

    closeOpenDate = (ev) => {
      this.setState({ dateModalIsOpen: !this.state.dateModalIsOpen });
    };


    save_old = (ev) => {
      ev.preventDefault();
      this.setState({ loading: true, errors: {} });
      let opening_hours_formData = {};
      const form = ev.currentTarget;
      const body = {
        opening_hours: this.rebuildOpeningBuildHours(),
      };
      const formData = new FormData(form);

      formData.append("_method", "put");
      body.opening_hours.map((hour, index) => {
        const attr_base_name = `opening_hours[${index}]`;
        opening_hours_formData[`${attr_base_name}[week_day]`] = hour.week_day;
        opening_hours_formData[`${attr_base_name}[opening_time]`] =
          hour.opening_time;
        opening_hours_formData[`${attr_base_name}[closing_time]`] =
          hour.closing_time;
      });

      //  

      Object.keys(opening_hours_formData).map((key) => {
        formData.append(key, opening_hours_formData[key]);
      });

      // API.put("business", body, { headers: this.props.headers })
      API({
        method: "POST",
        url: "business",
        headers: { ...this.props.headers, Accept: "*/*" },
        data: formData,
      })
        .then(
          ({ data }) => {
            if (data.success) {
              window.$.notify("Business settings updated", "success-alert");
            }
          },
          ({ response }) => {
            if (response.data?.errors) {
              response.data.errors.map((error) =>
                this.setState({
                  errors: {
                    ...this.state.errors,
                    [error.field]: error.message,
                  },
                })
              );
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    };


    save = (ev) => {
      ev.preventDefault();

      // const formButton = ev.currentTarget.querySelector("button[type=submit]");
      // formButton.classList.add("loading");

      //clear errors
      this.setState({ loading: true, errors: {} });

      const form = ev.currentTarget;
      const formData = {

        opening_hours: [],
      };
      let can_save = true;

      //rebuild opening hours...
      Object.keys(this.state.openHours).forEach((key) => {
        if (this.state.openHours[key] !== false)
          this.state.openHours[key].forEach((hour) => {

            if (hour.from === hour.to) {
              can_save = false;
              return window.$.notify("Opening and closing time can not be same.", "error-alert");
            }

            if (hour.to < hour.from) {
              can_save = false;
              return window.$.notify("Closing time can not be earlier than Opening time.", "error-alert");
            }
            if (hour.from > hour.to) {
              can_save = false;
              return window.$.notify("Opening time can not be later than Closing time.", "error-alert");
            }

            formData.opening_hours.push({
              week_day: key[0].toLocaleUpperCase() + key.slice(1),
              opening_time: hour.from == "00:00" ? "06:00" : hour.from,
              closing_time: hour.to == "00:00" ? "17:00" : hour.to,
            });
          });
      });

      if (!can_save) {
        this.setState({ loading: false });
        return false;
      }

      API({
        method: "PUT",
        url: "business/opening_hours",
        headers: { ...this.props.headers, Accept: "*/*" },
        data: formData,
      })
        .then(
          ({ data }) => {
            if (data.success) {
              window.$.notify("Business settings updated", "success-alert");
            }
          },
          ({ response }) => {
            if (response.data?.errors) {
              response.data.errors.map((error) =>
                this.setState({
                  errors: {
                    ...this.state.errors,
                    [error.field]: error.message,
                  },
                })
              );
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });

    };

    rebuildOpeningBuildHours = () => {
       
      let result = [];
      Object.keys(this.state.openHours).map((key) => {
        if (this.state.openHours[key] !== false) {
          this.state.openHours[key].map((hour) => {



            result.push({
              week_day: key,
              opening_time: hour.from,
              closing_time: hour.to,
            });
          });
        }
      });
      return result;
    };
    setCities = (city) => {
      if (this.props.locations)
        this.props.locations.map(({ name, cities }) => {
          if (name.toLowerCase() == city.toLowerCase()) {
            this.setState({ cities });
          }
        });
    };
    openHours = () => {
      return Object.keys(this.state.openHours).map((key) =>
        this.state.openHours[key] !== false ? (
          <div className="input-grid-rapper" >
            <p className="label">{key}</p>
            {this.state.openHours[key].map((hour) => (
              <div class="input-grid" style={{ pointerEvents: "none" }}>
                <Input type="text" placeholder="00:00" value={hour.from} />
                <span class="seperator">-</span>
                <Input type="text" placeholder="00:00" value={hour.to} />
              </div>
            ))}
          </div>
        ) : (
          ""
        )
      );
    };
    setOpeningHours = () => {
      let opening_hours_state = {};
      const opening_hours = this.props.business.opening_hours;

      if (opening_hours)
        opening_hours.map((e) => {
          if (!opening_hours_state[e.week_day])
            opening_hours_state[e.week_day] = [];
          opening_hours_state[e.week_day].push({
            from: e.opening_time,
            to: e.closing_time,
          });
        });
      //  
      this.hasSetOpenHours = true;
      this.setState({ openHours: opening_hours_state });
    };

    updateHours = (hoursState) => {
      let can_chnage = true;

      Object.keys(hoursState).forEach((key) => {
        if (hoursState[key]) {
       
       
          let from_key = hoursState[key][0].from?.split(' ')[0];
          let to_key = hoursState[key][0].to?.split(' ')[0];
          console.log([from_key, to_key, key])
          if (hoursState[key] && from_key === to_key) {
            can_chnage = false;
            return window.$.notify("Opening and closing time can not be same.", "error-alert");
          }

          if (hoursState[key] && to_key < from_key) {
            can_chnage = false;
            return window.$.notify("Closing time can not be earlier than Opening time.", "error-alert");
          }
          if (hoursState[key] && from_key > to_key) {
            can_chnage = false;
            return window.$.notify("Opening time can not be later than Closing time.", "error-alert");
          }
        }
      })
      if (can_chnage) {
        this.setState({
          openHours: { ...this.state.openHours, ...hoursState },
        });
         
      }
    };

    handleDateChange = (item) => {
      const newRange = item.selection;
      const { startDate, endDate } = newRange;
       

      // Update the state with the new range
      this.setState({
        dateRange: [newRange]
      });
    };

    getBookingSettings = () => {
      API.get("business/booking-settings", {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          this.props.dispatch({
            type: "GET_BOOKING_SETTINGS",
            data: { ...data.data, success: true },
          });
        },
        ({ response }) => {
          if (response.status == 403) {
            this.props.dispatch({
              type: "GET_BOOKING_SETTINGS",
              data: { success: false },
            });
          }
        }
      );
    };

    saveDate = () => {
      this.setState({ loading: true, errors: {} });

      let formData = {
        "start_date": this.state.dateRange[0].startDate.toDateString(),
        "end_date": this.state.dateRange[0].endDate.toDateString(),
        "is_single_day": this.state.dateRange[0].startDate.getDate() === this.state.dateRange[0].endDate.getDate() ? true : false
      }

      API({
        method: "POST",
        url: "/business/unavailable-dates",
        headers: { ...this.props.headers, Accept: "*/*" },
        data: formData,
      })
        .then(
          ({ data }) => {
            // if (data.success) {
            window.$.notify("Business settings updated", "success-alert");
            this.getBookingSettings();
            this.closeOpenDate();

            // }
          },
          ({ response }) => {
            if (response.data?.errors) {
              response.data.errors.map((error) =>
                this.setState({
                  errors: {
                    ...this.state.errors,
                    [error.field]: error.message,
                  },
                })
              );
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    deleteDate = (date_id) => {
      this.setState({ loading: true, errors: {} });


      API({
        method: "DELETE",
        url: "/business/unavailable-dates/" + date_id,
        headers: { ...this.props.headers, Accept: "*/*" }
      })
        .then(
          ({ data }) => {
            window.$.notify("Business settings updated", "success-alert");
            this.getBookingSettings();


          },
          ({ response }) => {
            if (response.data?.errors) {
              response.data.errors.map((error) =>
                this.setState({
                  errors: {
                    ...this.state.errors,
                    [error.field]: error.message,
                  },
                })
              );
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    render() {
       


      if (!this.hasSetOpenHours && this.props.business.id) {
        this.setOpeningHours();
      }


      return (
        <div className="onboarding-page">
          <Modal id="daysModel"
            isOpen={this.state.dateModalIsOpen}
            // onAfterOpen={afterOpenModal}
            // onRequestClose={this.closeOpenDate}
            style={customStyles}
            contentLabel=""
          >
            <h1 style={{ fontSize: "20px" }}>Select a date or range of dates</h1>
            <button style={{
              right: '0', top: '0', position: "absolute",
              padding: '0px',
              backgroundColor: '#eff2f7',
              margin: '10px',
              borderRadius: '50%',
              height: '35px',
              width: '35px'
            }} onClick={this.closeOpenDate}>x</button>
            <br />
            <DateRangePicker
              onChange={this.handleDateChange}
              showDateDisplay={false}
              months={1}
              minDate={addDays(new Date(), 0)}
              maxDate={addDays(new Date(), 365)}
              direction="horizontal"
              scroll={{ enabled: false }}
              ranges={this.state.dateRange}
            />
            <div>
              <button onClick={() => { this.saveDate() }} style={{ float: 'right' }}
                className={`default ${this.state.loading ? "loading" : ""
                  }`} disabled={this.state.loading ? true : false}>Save</button>
            </div>
          </Modal>


          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              <BackArrow />
              Opening Hours
            </h1>
            <div className="form-container card flex">
              <div>

                <h1 style={{ marginBottom: "10px" }} className="form-title dsk flex center">Opening hours</h1>
                <form
                  onSubmit={this.save}
                  className="restrict op-hours"
                  encType="multipart/form-data"
                >
                  <div >
                    <TimeInput
                      label="Monday"
                      defaultstate="closed"
                      // defaultValue={this.state.openHours}
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Tuesday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Wednesday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Thursday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Friday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Saturday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <TimeInput
                      label="Sunday"
                      defaultstate="closed"
                      updateHours={this.updateHours}
                      openHours={this.state.openHours}
                    />
                    <br></br>
                    <div className="flex center space-btw">
                      <button
                        className={`default ${this.state.loading ? "loading" : ""
                          }`}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div style={{ maxWidth: '400px' }} className="unav">



                <h1 style={{ marginBottom: "10px" }} className="form-title  flex ">Unavailable Dates
                  <button class="co-pink add" onClick={() => { this.closeOpenDate() }} style={{ marginLeft: '20px',position:'relative', bottom:'2px' }}><span style={{marginRight:4,position:'relative', top:'2.5px'}}><AddIcon/></span>Add a date</button>
                </h1>
                <div className="dates_">


                  {this.props && this.props.bookingSettings && this.props.bookingSettings.unavailableDates && this.props.bookingSettings.unavailableDates.length > 0 ?
                    this.props.bookingSettings.unavailableDates.map((item_, index) => (
                      <div className="flex" key={index}>
                        <span>
                          {item_.is_single_day === 1
                            ? moment(item_.start_date).format('Do MMM, YYYY') // If it's not a single day, show only start date
                            : moment(item_.start_date).format('Do MMM, YYYY') + " - " + moment(item_.end_date).format('Do MMM, YYYY')
                          }
                        </span>
                        <button onClick={() => {
                          this.deleteDate(item_.id)
                        }}
                          className={this.state.loading ? "loading" : ""}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none">
                            <path d="M1 5V17.5C1 18.3284 1.67157 19 2.5 19H11.5C12.3284 19 13 18.3284 13 17.5V5H1Z" fill="#E40587"></path>
                            <path fillRule="evenodd" clipRule="evenodd" d="M9 1.5V1C9 0.447715 8.55228 0 8 0H6C5.44772 0 5 0.447715 5 1V1.5H0.5C0.223858 1.5 0 1.72386 0 2V2.5C0 2.77614 0.223858 3 0.5 3H13.5C13.7761 3 14 2.77614 14 2.5V2C14 1.72386 13.7761 1.5 13.5 1.5H9Z" fill="#E40587"></path>
                          </svg>
                        </button>
                      </div>
                    )) :
                    (
                      <div>No unavailable dates</div> // If no unavailable dates, show a fallback message
                    )
                  }



                </div>

              </div>
            </div>

          </div>
        </div>
      );
    }
  }
);

const AddIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="11" width="16" height="2" rx="1" fill="#E40587" />
    <rect
      x="13"
      y="4"
      width="16"
      height="2"
      rx="1"
      transform="rotate(90 13 4)"
      fill="#E40587"
    />
  </svg>
);
